import { TransactionOnboardingType } from 'src/pages/transactions/types';
import { call } from '../@';

export default async function syncTransactionOnboarding(transactionId: string, type?: TransactionOnboardingType) {
	return await call('transactionOnboarding-sync', { transactionId, type });
}
